import styled from 'styled-components';

export const Description = styled.p`
  margin-top: 0;
`;

export const Email = styled.p`
  font-size: 1.1em;
  margin: 8px 0;
  text-align: center;
`;

export const Domain = styled.span<{ color: string }>`
  font-weight: 500;
  color: ${(props) => props.color};
`;
